import { DeleteOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import clsx from "clsx";

interface ImageType {
    id: string;
    url: string;
    name: string;
}

interface ImageItemProps {
    image: ImageType;
    selected: boolean;
    index: number;
    onSelect: (id: string) => void;
    onDelete: (id: string) => void;
}

export default function ImageItem({
    image,
    selected,
    index,
    onSelect,
    onDelete,
}: ImageItemProps) {
    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();

        Modal.confirm({
            title: "Xóa ảnh?",
            content: "Bạn có chắc muốn xóa ảnh này không?",
            okText: "Xóa",
            cancelText: "Hủy",
            okButtonProps: { danger: true },
            centered: true,

            onOk: () => {
                onDelete(image.id); // 🔥 chỉ xóa khi confirm
            },
        });
    };

    return (
        <div
            className={clsx(
                "relative rounded-xl border cursor-pointer overflow-hidden group",
                "border-gray-200 dark:border-gray-700",
                selected && "ring-2 ring-blue-500"
            )}
            onClick={() => onSelect(image.id)}
        >
            {/* IMAGE */}
            {/* IMAGE */}
            <img
                src={image.url}
                className="w-full h-24 object-cover pointer-events-none"
                draggable={false}
                alt=""
            />

            {/* NAME */}
            <div className="text-xs mt-1 px-1 truncate text-gray-700 dark:text-gray-300">
                {image.name}
            </div>

            {/* SELECT ORDER */}
            {selected && (
                <div className="absolute top-1 left-1 bg-blue-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {index + 1}
                </div>
            )}

            {/* HOVER ACTION */}
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
                <DeleteOutlined
                    onClick={handleDelete}
                    className="text-white text-lg cursor-pointer"
                />
            </div>
        </div>
    );
}